import request from '../utils/request';
import {Guid} from 'guid-typescript';

const url = 'scenic-spot/';

export function getMapInfo(): Promise<any> {
  return new Promise<any>(((resolve, reject) => {
    request({
      url: `${url}map-info`,
      method: 'get'
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  }));
}

export function getElTypes(): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}explanation-types`,
      method: 'get'
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}

export function getMapPoints(name: string, explanation?: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}map-point`,
      method: 'get',
      params: {
        name,
        explanation,
        isVaild: true,
        maxResultCount: 100
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}

export function getMapPointById(id: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}map-point/${id}`,
      method: 'get'
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}

export function getMapPointItems(pointId: Guid): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}map-point-item`,
      method: 'get',
      params: {
        pointId
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}

export function getLines(name: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}map-line`,
      method: 'get',
      params: {
        name
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}


export function getLineById(id: Guid): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}map-line/${id}`,
      method: 'get'
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}

export function getIp(ip: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}weather/ip`,
      method: 'get',
      params: {
        ip
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}

export function getNavigationAsync(roomId: string, startId: string, endId: string): Promise<any> {
  return new Promise<any>((resolve, reject) => {
    request({
      url: `${url}map-line/navigation`,
      method: 'get',
      params: {
        roomId,
        startId,
        endId
      }
    }).then((res) => resolve(res.data)).catch((err) => reject(err));
  });
}
